"use client";

import ThemeCard from "@/components/pages/hotel/cards/ThemeCard.jsx";
import DistrictList from "@/components/pages/hotel/sections/DistrictList";
import CityThemeList from "@/components/pages/hotel/sections/CityThemeList";
import HotelAbout from "@/components/pages/hotel/sections/HotelAbout";
import CityInsight from "@/components/pages/hotel/sections/CityInsight";
import PopularLocationCard from "@/components/PopularLocationCard";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import { BlogCard, CampaignCard } from "@/components/featured/common";

export const hotelHomeComponentRegistry = {
  OpportunitiesCardWrapper,
  ThemeCard,
  CampaignCard,
  BlogCard,
  DistrictList,
  CityThemeList,
  HotelAbout,
  CityInsight,
  PopularLocationCard
};

export const hotelHomeItemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  ThemeCard: "item",
  BlogCard: "post",
  DistrictList: "item",
  CityThemeList: "item",
  HotelAbout: "item",
  CityInsight: "item",
  PopularLocationCard: "item"
};
